import { Font } from "@react-pdf/renderer";
export function registerPdfFonts(directory) {
    const base = directory.replace(/[\\/]+$/, "");
    Font.register({
        family: "Roboto",
        fonts: [
            { src: `${base}/Roboto-Regular.ttf` },
            { src: `${base}/Roboto-Bold.ttf`, fontWeight: "bold" },
            { src: `${base}/Roboto-Black.ttf`, fontWeight: "heavy" },
            { src: `${base}/Roboto-Italic.ttf`, fontStyle: "italic" },
        ],
    });
}
//# sourceMappingURL=fonts.js.map